import React from "react"
import Checkbox from './Checkbox';

const AdminEditorCheckboxes = ({handleSelectAdmin, users, recipients}) => {
  const assignedEditor = () => {
    return users.find( (user) => { return user.isAssignedToArticle })
  }

  const unAssignedEditors = () => {
    return users.filter( (user) => { return !user.isAssignedToArticle })
  }

  const renderAssignedEditorCheckbox = () => {
    let checkbox;
    if (assignedEditor()) {
      checkbox = <Checkbox
                      user={assignedEditor()}
                      handleSelectAdmin={handleSelectAdmin}
                      recipients={recipients}
                    />
    } else {
      checkbox = <p>None</p>
    }
    return (
      <div className="checkboxes">
        <strong>Assigned Admin/Editor</strong>
        {checkbox}
      </div>
    )
  }

  const renderOtherEditorCheckboxes = () => {
    let checkboxes = unAssignedEditors().map( (user) => {
      return (
        <Checkbox
          key={user.id}
          user={user}
          handleSelectAdmin={handleSelectAdmin}
          recipients={recipients}
        />
      );
    });

    return (
      <div className="checkboxes">
        <strong>Channel Admins & Editors</strong>
        {checkboxes}
      </div>
    )
  }

  return (
    <>
      {renderAssignedEditorCheckbox()}
      {renderOtherEditorCheckboxes()}
    </>
  )
}

export default AdminEditorCheckboxes